import {faPencilAlt, IconDefinition} from '@fortawesome/free-solid-svg-icons';
import React, { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { EditProps, TableRow } from '../models/table-models';
import { CustomButton } from './CustomButton';
import { Role } from '../utils/Enums/Roles';
import { AuthContext } from '../context/AuthContext';

export const EditActionComponent = <T extends TableRow>({
    title,
    editComponent,
    accessEditRoles,
    item,
    refetchEntitiesHook,
    editIcon,
    disabled,
    ownDialog,
    editFooterAction,
}: {
    editComponent: ({ itemToEdit, setShowModal }: EditProps<T>) => JSX.Element;
    editFooterAction?: ({
        item,
        refetchEntitiesHook,
        setShowModal,
    }: {
        item: T;
        refetchEntitiesHook: () => void;
        setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    }) => React.ReactNode;
    accessEditRoles?: Role[];
    item: T;
    title: string;
    refetchEntitiesHook: () => void;
    editIcon?: IconDefinition;
    disabled?: boolean;
    ownDialog?: boolean;
}) => {
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { hasPermission } = useContext(AuthContext);

    const EditComponent = editComponent;
    return (
        <>
            <CustomButton
                icon={editIcon ?? faPencilAlt}
                iconClass='fa-fw'
                onClick={() => setShowModal(true)}
                className='me-1 color-main'
                disabled={
                    disabled ||
                    (accessEditRoles && !hasPermission([...accessEditRoles, Role.ADMIN]))
                }
            />
            {ownDialog ? showModal && createPortal(
                <EditComponent itemToEdit={item} setShowModal={setShowModal} {...{ refetchEntitiesHook }} />,
                document.body
            )
            : <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" size='lg' centered>
                <Modal.Header closeButton>
                    <Modal.Title id='contained-modal-title-vcenter'>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditComponent itemToEdit={item} setShowModal={setShowModal} {...{ refetchEntitiesHook }} />
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-between'>
                    <Button onClick={() => setShowModal(false)}>{t('close')}</Button>
                    <div className='d-flex gap-2'>
                        {editFooterAction?.({ item, refetchEntitiesHook, setShowModal })}
                        <Button form='form' type='submit' className='btn-success'>
                            {t('save')}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>}
        </>
    );
};
